import React from "react";
import { toNumericStyleValue } from "../../Uitls/Util";
import {
  buildStrokeOnlySvgSrc,
  getShapeStrokeZIndex,
  getShapeSvgSource,
  hasVisibleShapeBorder,
  isCssBorderShapeType,
  isShapeMatchingCanvasSize,
  isSvgShapeType,
} from "../../Uitls/shapeStrokeOverlay";
import { useEditorMainPageContext } from "../contexts/EditorMainPageContext";

/**
 * Frame painted above overlapping content only when the shape is the same
 * size as the canvas (full-bleed). Smaller shapes keep their normal border.
 */
export const EditorCanvasShapeStrokeOverlay = ({ items }) => {
  const { canvasDimension } = useEditorMainPageContext();
  if (items?.componentType !== "Shape") return null;

  const styles = items.componentStyles || {};
  if (styles.hideBoolean) return null;
  if (!isShapeMatchingCanvasSize(styles, canvasDimension)) return null;

  const shapeType = items.textComponentType?.addContent;
  const left =
    toNumericStyleValue(styles.left) + (parseInt(styles.translateX, 10) || 0);
  const top =
    toNumericStyleValue(styles.top) + (parseInt(styles.translateY, 10) || 0);

  const sharedStyle = {
    position: "absolute",
    left,
    top,
    width: styles.width,
    height: styles.height,
    zIndex: getShapeStrokeZIndex(styles.zIndex),
    pointerEvents: "none",
    boxSizing: "border-box",
    background: "transparent",
    opacity:
      styles.compOpacity === 100 || styles.compOpacity == null
        ? styles.opacity
        : styles.compOpacity / 100,
    webkitTransformOrigin: `${styles.transformOriginX}% ${styles.transformOriginY}% ${styles.transformOriginZ}px`,
    transform: `rotate(${styles.rotation || 0}) rotateX(${
      styles.rotationX || 0
    }) rotateY(${styles.rotationY || 0}) scale(${styles.scale ?? 1})`,
  };

  if (isCssBorderShapeType(shapeType)) {
    if (!hasVisibleShapeBorder(styles.border)) return null;
    return (
      <div
        aria-hidden
        data-shape-stroke="true"
        data-shape-stroke-for={items.id}
        style={{
          ...sharedStyle,
          border: styles.border,
          borderRadius:
            shapeType === "circleShape"
              ? styles.borderRadius
              : undefined,
          borderTopLeftRadius:
            shapeType === "rectangleShape"
              ? styles.borderTopLeftRadius
              : undefined,
          borderTopRightRadius:
            shapeType === "rectangleShape"
              ? styles.borderTopRightRadius
              : undefined,
          borderBottomLeftRadius:
            shapeType === "rectangleShape"
              ? styles.borderBottomLeftRadius
              : undefined,
          borderBottomRightRadius:
            shapeType === "rectangleShape"
              ? styles.borderBottomRightRadius
              : undefined,
        }}
      />
    );
  }

  if (isSvgShapeType(shapeType)) {
    const svgSrc = getShapeSvgSource(items);
    const strokeSrc = buildStrokeOnlySvgSrc(svgSrc);
    if (!strokeSrc) return null;
    return (
      <div
        aria-hidden
        data-shape-stroke="true"
        data-shape-stroke-for={items.id}
        style={sharedStyle}
      >
        <img
          alt=""
          src={strokeSrc}
          style={{
            width: "100%",
            height: "100%",
            display: "block",
            pointerEvents: "none",
          }}
        />
      </div>
    );
  }

  return null;
};
